import MyCoursesModule from './containers/myCoursesModule'

export {default as MyCoursesModuleLayout} from './components/myCoursesModuleLayout'

export default MyCoursesModule
